import React, { useState, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { muestraContext } from '../../../pages/Normas/Muestras'
import { NormasContext } from '../../../context/NormasContext'
import "./ModalNewMuestra.scss"

function ModalNewMuestra(props) {

    const { user, tipo, idSubtarea  } = useContext(muestraContext)
    const { fetchMuestras } = useContext(NormasContext)

    const [file, setFile] = useState("")
    const [descripcion, setDescripcion] = useState("")

    const [errors, setErrors] = useState({})
    const [errorFetch, setErrorFetch] = useState(null)

    const handleClose = () => {
        setErrors({})
        setErrorFetch(null)
        setFile("")
        setDescripcion("")
        props.onHide()
    }

    const handleChangeFile = (e) => {
        setFile(e.target.files[0])
    }

    const handleChange = (e) => {
        setDescripcion(e.target.value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        let errors = {}

        if(tipo === 1){
            if (!file) {
                errors.evidencia = "Agregue un archivo válido.";
            }
        }

        if(tipo === 2 || tipo === 3){
            if (!descripcion.trim()) {
                errors.evidencia = tipo === 2 ? "Ingrese un link válido." : "Ingrese un texto válido.";
            }
        }

        if((Object.keys(errors).length === 0)){
            setErrors(null)
            const formData = new FormData()
            formData.append('idsubtarea', idSubtarea)
            formData.append('tipo', tipo)
            formData.append('user', JSON.stringify(user))

            if(tipo === 1) {
                formData.append('file', file)
                formData.append('titulo', file.name)
            } else {
                formData.append('descripcion', descripcion)
            }

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/addMuestra`, {
                    method: "POST",
                    body: formData
                })
                const data = await res.json()
                if(data.status !== 0){
                    setErrorFetch(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // actualizar muestras
                    fetchMuestras({
                        idsubtarea: idSubtarea
                    })
                }
            } catch (error) {
                setErrorFetch("Error: Conexión con backend.")
            }
        } else {
            setErrors(errors)
        }

    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__muestra'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>
                        {tipo === 1 && "Carga de archivo"}
                        {tipo === 2 && "Link"}
                        {tipo === 3 && "Texto"}
                    </h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {tipo === 1 && (
                    <form className='form__muestra d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                        <div className='w-100 mb-4'>
                            <input 
                                type='file'
                                onChange={handleChangeFile}
                                className={`w-auto form-control rounded-pill border no-outline focus-ring ${
                                    errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                }`}
                            />
                        </div>
                        {errors?.evidencia && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errors?.evidencia}</span>
                        )}
                        {errorFetch !== null && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorFetch}</span>
                        )}
                        <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>+ agregar evidencia</button>
                    </form>
                )}
                {tipo === 2 && (
                    <form className='form__muestra d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                        <div className='w-100 mb-4'>
                            <input
                                type="text" 
                                id="link" 
                                name="link" 
                                placeholder='https://'
                                value={descripcion}
                                onChange={handleChange}
                                autoFocus
                                className={`w-100 form-control border no-outline focus-ring ${
                                    errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                }`}
                            />
                        </div>
                        {errors?.evidencia && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errors?.evidencia}</span>
                        )}
                        {errorFetch !== null && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorFetch}</span>
                        )}
                        <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>+ agregar evidencia</button>
                    </form>
                )}
                {tipo === 3 && (
                    <form className='form__muestra d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                        <div className='w-100 mb-4'>
                            <textarea 
                                name="textoLargo" 
                                id="textoLargo" 
                                placeholder='Texto largo'
                                value={descripcion}
                                onChange={handleChange}
                                autoFocus
                                rows="5"
                                className={`w-100 form-control border no-outline focus-ring ${
                                    errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                }`}
                            ></textarea>
                        </div>
                        {errors?.evidencia && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errors?.evidencia}</span>
                        )}
                        {errorFetch !== null && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorFetch}</span>
                        )}
                        <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>+ agregar evidencia</button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default ModalNewMuestra